import React from "react";

export default function useHighlightMatch() {
  function highlightMatch(text, query) {
    if (!query) {
      return text;
    }
    const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const parts = text.split(new RegExp(`(${escaped})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <mark className="bottom-nav__hl" key={index}>
          {part}
        </mark>
      ) : (
        <React.Fragment key={index}>{part}</React.Fragment>
      )
    );
  }

  return highlightMatch;
}
